import React from "react";
import AuditQueue from "./AuditQueue";

const PvAuditDashboard = () => (
  <AuditQueue
    type="pvs"
    stage={1}
    title="PV Audit Dashboard"
    subtitle="Payment vouchers in the audit track. Every PV enters audit once it is created."
  />
);

export default PvAuditDashboard;
